export default "/images/vendor/flag-icons/flags/1x1/un.svg?61c437d90a5a5757d696234053f46a57";